import {Component, input} from '@angular/core';

@Component({
  selector: 'app-block-style-header',
  standalone: true,
  imports: [],
  templateUrl: './block-style-header.component.html',
  styleUrl: './block-style-header.component.css'
})
export class BlockStyleHeaderComponent {
  data = input<any>();
}
